
import { computed, defineComponent, reactive, ref } from 'vue';
import { Form, message } from 'ant-design-vue';
import { MailOutlined } from '@ant-design/icons-vue';

import { useRouter } from 'vue-router';
import { change_password_by_mobile, send_retrieve_password_sms_code } from "@/api/sys-model";

const levelNames: Record<number, string> = {
  0: '低',
  1: '低',
  2: '中',
  3: '强',
};
const levelClass: Record<number, string> = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success',
};
const levelColor: Record<number, string> = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a',
};

export default defineComponent({
  setup() {
    const router = useRouter();
    const state = reactive({
      time: 60,
      smsSendBtn: false,
      passwordLevel: 0,
      passwordLevelChecked: false,
      percent: 10,
      progressColor: '#FF0000',
      registerBtn: false,
    });
    const modelRef: any = reactive({
      username: '',
      password: '',
      password2: '',
      code: null,
      num: null,
    });
    const loginBtn = ref(false);
    const rulesRef = reactive({
      email: [{ required: true, message: '请输入邮箱地址', trigger: ['blur'] }],
      password: [
        { required: true, message: '至少6位密码，区分大小写' },
        {
          validator: (_rule: any, value: any) => {
            return new Promise((resolve, reject) => {
              let level = 0;

              // 判断这个字符串中有没有数字
              if (/[0-9]/.test(value)) {
                level++;
              }
              // 判断字符串中有没有字母
              if (/[a-zA-Z]/.test(value)) {
                level++;
              }
              // 判断字符串中有没有特殊符号
              if (/[^0-9a-zA-Z_]/.test(value)) {
                level++;
              }
              state.passwordLevel = level;
              state.percent = level * 30;
              if (level >= 2) {
                if (level >= 3) {
                  state.percent = 100;
                }
                resolve(null);
              } else {
                if (level === 0) {
                  state.percent = 10;
                }
                reject(new Error('密码强度不够'));
              }
            });
          },
        },
      ],
      password2: [
        { required: true, message: '至少6位密码，区分大小写' },
        {
          validator: (_rule: any, value: string) => {
            return new Promise((resolve, reject) => {
              const password = modelRef.password;
              if (value === undefined) {
                reject(new Error('请输入密码'));
              }
              if (value && password && value.trim() !== password.trim()) {
                reject(new Error('两次密码不一致'));
              }
              resolve(null);
            });
          },
        },
      ],
      mobile: [
        {
          required: true,
          message: '请输入正确的手机号',
          pattern: /^1[3456789]\d{9}$/,
          trigger: ['blur'],
        },
      ],
      code: [{ required: true, message: '请输入验证码', trigger: ['blur'] }],
    });
    const { validateInfos, validate } = Form.useForm(modelRef, rulesRef);

    const handlePasswordInputClick = () => {
      state.passwordLevelChecked = true;
    };

    const handleGetCode = () => {
      validate(['username', 'mobile']).then(values => {
        modelRef.num = 60;
        const timer = setInterval(() => {
          modelRef.num--;
          if (modelRef.num < 0) {
            clearInterval(timer);
          }
        }, 1000);
        send_retrieve_password_sms_code({
          username: modelRef.username,
          mobile: values.mobile,
        })
          .then(() => {
            message.success('验证码获取成功');
          })
          .catch(() => {
            modelRef.num = 0;
          });
      });
    };
    const handleUpdatePassword = () => {
      validate(['username', 'mobile', 'password', 'password2', 'code']).then(values => {
        loginBtn.value = true;
        change_password_by_mobile({
          username: values.username,
          mobile: values.mobile,
          code: values.code,
          newpassword: values.password,
        })
          .then(() => {
            message.success('修改密码成功');
            router.push({
              path: '/user/login',
            });
          })
          .finally(() => {
            loginBtn.value = false;
          });
      });
    };
    const handleLogin = () => {
      router.push({
        path: '/user/login',
      });
    };
    return {
      state,
      modelRef,
      validateInfos,
      handlePasswordInputClick,
      loginBtn,
      handleUpdatePassword,
      handleGetCode,
      handleLogin,

      passwordLevelClass: computed(() => levelClass[state.passwordLevel]),
      passwordLevelName: computed(() => levelNames[state.passwordLevel]),
      passwordLevelColor: computed(() => levelColor[state.passwordLevel]),
    };
  },
  components: {
    MailOutlined,
  },
});
